export const isEnrollioStaffEmail = (
  email: string | null | undefined,
): boolean => {
  if (!email) {
    return false;
  }
  return email.trim().toLowerCase().endsWith('@enrollio.ai');
};
